import { LoadingButton } from '../buttons/loading-button';
import { Button } from '../button';

type DefaultFormFooterProps = {
  canSubmit: boolean;
  isSubmitting: boolean;
  resetText?: string;
  submitText?: string;
};

export function DefaultFormFooter({
  canSubmit,
  isSubmitting,
  resetText = 'Avbryt',
  submitText = 'Spara',
}: DefaultFormFooterProps) {
  return (
    <div className="flex gap-2 float-right justify-end">
      <Button variant="outline" type="reset" disabled={isSubmitting}>
        {resetText}
      </Button>
      <LoadingButton disabled={!canSubmit} isLoading={isSubmitting} type="submit">
        {submitText}
      </LoadingButton>
    </div>
  );
}
